import { render, staticRenderFns } from "./SceneDetectionThumbnail.vue?vue&type=template&id=2772e250&scoped=true&"
import script from "./SceneDetectionThumbnail.vue?vue&type=script&lang=js&"
export * from "./SceneDetectionThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./SceneDetectionThumbnail.vue?vue&type=style&index=0&id=2772e250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2772e250",
  null
  
)

export default component.exports